import actionCreator from '../../createAction';

const createAction = actionCreator('conversations');

export const GET_PENDING_MESSAGES = createAction('GET_PENDING_MESSAGES');
export const GET_PENDING_GROUP_MESSAGES = createAction(
  'GET_PENDING_GROUP_MESSAGES',
);
export const GET_SENT_GROUP_MESSAGES = createAction('GET_SENT_GROUP_MESSAGES');
export const TOGGLE_MESSAGES_TYPE = createAction('TOGGLE_MESSAGES_TYPE');
export const GET_SENT_MESSAGES = createAction('GET_SENT_MESSAGES');
export const GET_INBOXES = createAction('GET_INBOXES');
export const SET_ACTIVE_INBOX = createAction('SET_ACTIVE_INBOX');
export const GET_CONVERSATIONS = createAction('GET_CONVERSATIONS');
export const UPDATE_CONVERSATION = createAction('UPDATE_CONVERSATION');
export const UPDATE_CONVERSATIONS = createAction('UPDATE_CONVERSATIONS');
export const GET_ARCHIVED_CONVERSATIONS = createAction(
  'GET_ARCHIVED_CONVERSATIONS',
);
export const GET_MESSAGES = createAction('GET_MESSAGES');
export const CREATE_INBOX = createAction('CREATE_INBOX');
export const CREATE_MESSAGE = createAction('CREATE_MESSAGE');
export const DELETE_MESSAGE = createAction('DELETE_MESSAGE');
export const UPDATE_MESSAGE = createAction('UPDATE_MESSAGE');
export const GET_NEW_MESSAGE_COUNT = createAction('GET_NEW_MESSAGE_COUNT');
export const ARCHIVE_CONVERSATIONS = createAction('ARCHIVE_CONVERSATIONS');
export const ARCHIVE_ALL_CONVERSATIONS = createAction(
  'ARCHIVE_ALL_CONVERSATIONS',
);
export const OPTED_OUT_CONVO = createAction('OPTED_OUT');
export const SEND_REPLY_MESSAGE = createAction('SEND_REPLY_MESSAGE');
export const GET_UNACTIONED_CONVO_INBOX = createAction(
  'GET_UNACTIONED_CONVO_INBOX',
);
export const GET_UNACTIONED_CONVO_ARCHIVED = createAction(
  'GET_UNACTIONED_CONVO_ARCHIVED',
);
